import { useId } from "react";

/** Inline, theme-aware metal folds: visible in the server document without an image request. */
export function StocksHeroArtwork() {
  const id = useId();
  const rearId = `${id}-rear`;
  const faceId = `${id}-face`;
  const undersideId = `${id}-underside`;
  const edgeId = `${id}-edge`;

  return (
    <svg
      aria-hidden="true"
      className="pointer-events-none absolute inset-y-0 -right-[45%] h-full w-[125%] opacity-40 [mask-image:linear-gradient(to_right,transparent,black_36%)] sm:-right-[18%] sm:w-[95%] sm:opacity-60 lg:right-0 lg:w-[72%] lg:opacity-100"
      data-testid="stocks-hero-artwork"
      fill="none"
      focusable="false"
      preserveAspectRatio="xMaxYMid slice"
      viewBox="0 0 1100 240"
    >
      <defs>
        <linearGradient id={rearId} x1="0" x2="0.2" y1="0" y2="1">
          <stop stopColor="var(--foreground)" stopOpacity="0.02" />
          <stop
            offset="0.32"
            stopColor="var(--foreground)"
            stopOpacity="0.09"
          />
          <stop offset="0.62" stopColor="var(--foreground)" stopOpacity="0.3" />
          <stop offset="0.72" stopColor="var(--foreground)" stopOpacity="0.1" />
          <stop offset="1" stopColor="var(--foreground)" stopOpacity="0.01" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={faceId}
          x1="742"
          x2="782"
          y1="24"
          y2="216"
        >
          <stop stopColor="var(--foreground)" stopOpacity="0.015" />
          <stop
            offset="0.25"
            stopColor="var(--foreground)"
            stopOpacity="0.12"
          />
          <stop
            offset="0.47"
            stopColor="var(--foreground)"
            stopOpacity="0.62"
          />
          <stop
            offset="0.53"
            stopColor="var(--foreground)"
            stopOpacity="0.22"
          />
          <stop
            offset="0.77"
            stopColor="var(--foreground)"
            stopOpacity="0.06"
          />
          <stop offset="1" stopColor="var(--foreground)" stopOpacity="0.015" />
        </linearGradient>
        <linearGradient id={undersideId} x1="0" x2="0" y1="0" y2="1">
          <stop stopColor="var(--foreground)" stopOpacity="0.18" />
          <stop
            offset="0.32"
            stopColor="var(--foreground)"
            stopOpacity="0.035"
          />
          <stop offset="1" stopColor="var(--foreground)" stopOpacity="0" />
        </linearGradient>
        <linearGradient id={edgeId} x1="0" x2="1" y1="0" y2="0">
          <stop stopColor="var(--foreground)" stopOpacity="0" />
          <stop offset="0.4" stopColor="var(--foreground)" stopOpacity="0.08" />
          <stop
            offset="0.72"
            stopColor="var(--foreground)"
            stopOpacity="0.62"
          />
          <stop offset="1" stopColor="var(--foreground)" stopOpacity="0.12" />
        </linearGradient>
      </defs>
      <path
        d="M220 274C402 196 512 83 718 26C882-20 1032-5 1160 36L1160 102C1014 38 877 26 733 57C533 101 413 216 220 274Z"
        fill={`url(#${rearId})`}
      />
      <path
        d="M40 270C306 250 432 163 638 113C830 67 1004 118 1160 231L1160 282C1000 168 826 110 652 137C442 177 303 260 40 270Z"
        fill={`url(#${undersideId})`}
      />
      <path
        d="M40 270C316 236 413 133 620 57C819-16 1010 24 1160 105L1160 231C1004 118 830 67 638 113C432 163 306 250 40 270Z"
        fill={`url(#${faceId})`}
      />
      <path
        d="M40 270C306 250 432 163 638 113C830 67 1004 118 1160 231"
        stroke={`url(#${edgeId})`}
        strokeWidth="1"
        vectorEffect="non-scaling-stroke"
      />
    </svg>
  );
}
